// eslint-disable-next-line no-unused-vars
var Menu = function () {

    function init () {
        $('.main-menu__button').click(function(){
            $('.main-menu').toggleClass('main-menu--open');
        });
        $('.main-menu ul a').click(function() {
            $('.main-menu').removeClass('main-menu--open');
        });

        $('.main-menu [href="#contact"]').click(function(event) {
            event.preventDefault();
            console.log($('.header').height());
            $('html,body').animate({ scrollTop: $('#contact').offset().top - $('.header__background').height() + 1}, 800);
        });
    }

    return {
        init: init
    }
}();